// Stealth Angel rebuild: keeps variant-dependent blocks (savings, stock bar, availability, free-shipping badge)
// in step with the selected variant. Horizon re-renders only its own components on a variant change; it does fetch
// the whole section, so each <sas-variant-refresh data-key> copies itself from that fetched HTML.
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class SasVariantRefresh extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        const next = detail?.html?.querySelector(`sas-variant-refresh[data-key="${CSS.escape(this.dataset.key)}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[sas-variant-refresh]', error);
      });
  };
}

if (!customElements.get('sas-variant-refresh')) customElements.define('sas-variant-refresh', SasVariantRefresh);
